/**
 * iOS Video Fix for Product Cards
 * Corrige problemas de autoplay de vídeo no iOS
 */
(function() {
    'use strict';
    
    // Detecta se é dispositivo iOS
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    
    // Função para forçar play nos vídeos
    function forceVideoPlay(video) {
        if (!video) return;
        
        const playPromise = video.play();
        
        if (playPromise !== undefined) {
            playPromise.then(() => {
                // Vídeo reproduziu com sucesso
                console.log('Video autoplay started');
            }).catch(error => {
                // Falha no autoplay - pode ser política do browser
                console.log('Video autoplay prevented:', error);
                
                // Tenta novamente após interação do usuário
                document.addEventListener('touchstart', function() {
                    video.play().catch(e => console.log('Retry video play failed:', e));
                }, { once: true });
            });
        }
    }
    
    // Função para configurar vídeos nos cartões de produto
    function setupProductCardVideos() {
        const productCards = document.querySelectorAll('.product-item .card');
        
        productCards.forEach(card => {
            const videos = card.querySelectorAll('video');
            
            videos.forEach(video => {
                // Garante que os atributos estejam corretos para iOS
                video.setAttribute('playsinline', '');
                video.setAttribute('muted', '');
                video.setAttribute('loop', '');
                
                // Para vídeos que devem reproduzir automaticamente
                if (card.classList.contains('has-first-video')) {
                    // Configura intersectionObserver para reproduzir quando visível
                    const observer = new IntersectionObserver((entries) => {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                setTimeout(() => {
                                    forceVideoPlay(video);
                                }, 100);
                            } else {
                                video.pause();
                            }
                        });
                    }, {
                        threshold: 0.1
                    });
                    
                    observer.observe(card);
                }
                
                // Para outros vídeos (hover effect)
                else {
                    if (window.innerWidth > 1200) {
                        card.addEventListener('mouseenter', () => {
                            forceVideoPlay(video);
                        });
                        
                        card.addEventListener('mouseleave', () => {
                            video.pause();
                        });
                    }
                }
                
                // Eventos para iOS touch
                if (isIOS) {
                    card.addEventListener('touchstart', () => {
                        forceVideoPlay(video);
                    }, { passive: true });
                }
            });
        });
    }
    
    // Função para ser chamada quando novos produtos são carregados via AJAX
    window.initializeProductCardVideos = setupProductCardVideos;
    
    // Inicializa quando o DOM estiver pronto
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', setupProductCardVideos);
    } else {
        setupProductCardVideos();
    }
    
    // Re-inicializa após mudanças no DOM (para AJAX)
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.querySelector && node.querySelector('.product-item')) {
                        setTimeout(setupProductCardVideos, 100);
                    }
                });
            }
        });
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
})();